export const FILTER_CONFIG_DIVIDEND = {
  walletIds: { type: 'array' as const },
  search: { type: 'string' as const },
  dateFrom: { type: 'string' as const },
  dateTo: { type: 'string' as const },
  sorterField: { type: 'string' as const },
}

export const FILTER_CONFIG_COMMISSION = {
  walletIds: { type: 'array' as const },
  dateFrom: { type: 'string' as const },
  dateTo: { type: 'string' as const },
  currencies: { type: 'array' as const },
  type: { type: 'string' as const },
  sorterField: { type: 'string' as const },
}

export const FILTER_CONFIG_EX_DIFFERENCE = {
  walletIds: { type: 'array' as const },
  currencies: { type: 'array' as const },
  dateFrom: { type: 'string' as const },
  dateTo: { type: 'string' as const },
  sorterField: { type: 'string' as const },
}

export const PERIOD_OPTIONS = [
  { label: 'This week', value: 'this_week' },
  { label: 'This month', value: 'this_month' },
  { label: 'This quarter', value: 'this_quarter' },
  { label: 'Last week', value: 'last_week' },
  { label: 'Last month', value: 'last_month' },
  { label: 'Last quarter', value: 'last_quarter' },
  { label: 'Date Range', value: 'date_range' },
]

export const TYPE_OPTIONS = [
  { label: 'Transaction Commission', value: 'transactionCommission' },
  { label: 'Manual commission', value: 'manualCommission' },
]
